import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const authHeader = () => ({ Authorization: `Bearer ${localStorage.getItem('token') || ''}` });

export default function StudentGroups(){
    const nav = useNavigate();
    const [groups, setGroups] = useState([]);
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState('');

    useEffect(() => {
        let cancelled = false;
        (async () => {
            setLoading(true); setErr('');
            try {
                const r = await fetch('/api/student/grupy', { credentials:'include', headers:{ ...authHeader() } });
                if (!r.ok) throw new Error((await r.json().catch(()=>({})))?.blad || `Błąd (${r.status})`);
                const j = await r.json();
                if (!cancelled) setGroups(Array.isArray(j) ? j : []);
            } catch(e){ if (!cancelled) setErr(e.message || 'Błąd pobierania'); }
            finally { if (!cancelled) setLoading(false); }
        })();
        return () => { cancelled = true; };
    }, []);

    return (
        <div style={{ maxWidth: 1000, padding:'0 16px', marginTop:80 }}>
            <h1>Moje grupy</h1>

            <div style={{ display:'flex', gap:8, margin:'12px 0 20px' }}>
                <button className={'but-smal'}
                                 onClick={() => nav('/student/grupa/dodaj-kod')}
                    style={{ border:'1px solid #e5e7eb', borderRadius:8 }}>
                    + Dołącz do grupy za pomocą kodu
                </button>
            </div>

            {loading ? (
                <div>Ładowanie…</div>
            ) : err ? (
                <div style={{ color:'crimson' }}>{err}</div>
            ) : groups.length === 0 ? (
                <div style={{ border:'1px dashed #d1d5db', borderRadius:12, padding:20, color:'#6b7280' }}>
                    Nie należysz jeszcze do żadnej grupy.
                </div>
            ) : (
                <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(260px,1fr))', gap:12 }}>
                    {groups.map(g => (
                        <button key={g.group_id}
                                onClick={()=>nav(`/student/grupa/${g.group_id}`)}
                                style={{ textAlign:'left', border:'1px solid #e5e7eb', borderRadius:12, padding:14, background:'#fff', cursor:'pointer' }}>
                            <div style={{ fontWeight:700, fontSize:16 }}>{g.group_name}</div>
                            <div style={{ color:'#6b7280', fontSize:13, marginTop:4 }}>
                                {g.field_of_study || '—'} • semestr {g.study_semester ?? '—'} • {g.study_mode || '—'}
                            </div>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
